/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"pa":{"categories":{"cardinal":["one","other"],"ordinal":["other"]},"fn":function(n, ord) {
  if (ord) return 'other';
  return (n == 0 || n == 1) ? 'one' : 'other';
}}},"aliases":{"pa-IN":"pa-Guru-IN","pa-PK":"pa-Arab-PK"},"parentLocales":{},"availableLocales":["pa"]})
}
